<template>
  <div class="sip-start">

    <!-- <Game v-if="step === 1" class="sip-root-game" /> -->

    <div class="sip_preloader">
      <img v-if="$isMob" :src="`${$server}start_mob_2x.jpg`" />
      <img v-else :src="`${$server}start_2x.jpg`" />

      <div class="sip_preloader_text">
        <div>
          <div class="sip_preloader_title">Заправляем СПГ :)</div>
          <div class="sip_preloader_body">
            Не только автомобили становятся более «зелеными» — морской транспорт не отстает. Один из перспективных вариантов нового судового топлива — сжиженный природный газ. В России появился первый бункеровщик, заправляющий суда на СПГ. Узнайте о нем побольше — и примерьте на себя роль его капитана.
          </div>
          <div v-if="!starting">
            <div @click="onStart" class="sip_start">
              <span>Играть</span>
            </div>
          </div>
          <div v-else>
            <div class="sip_start_progress" >
              <span class="sip_start_progress_line" :style="`width: ${progress}%`" />
              <span class="sip_start_progress_text" v-html="`Загрузка ${Math.round(progress)}%`" />
              <span class="sip_start_progress_bg" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  name: 'Start',
  data() {
    return {
      loadingComplete: false,
      starting: false,
    }
  },
  props: {
    progress: Number,
  },
  watch: {
    progress(val){
      if(val > 99) {
        this.loadingComplete = true
        if(this.starting) {
          this.$emit('clicked', false)
        }
      }
    }
  },
  methods: {
    onStart() {
      if(this.loadingComplete) {
        this.$emit('clicked', false)
      }else{
        this.starting = true
      }
    }
  }
}
</script>

<style lang="stylus">
.sip-start
  // background-color #042f3c
  background-color #FFF
  width 100%
  height 100vh
  font-family 'Roboto', sans-serif

.sip_start_progress
  border 1px solid red
  max-width 700px
  height 40px
  background linear-gradient(180deg, #4E737E 0%, #435C64 100%)
  border 1px solid #FFFFFF
  box-shadow inset 0px 4px 0px rgba(0, 0, 0, 0.25)
  border-radius 6px
  position relative
  @media screen and (max-width: 900px)
    height 35px
  .sip_start_progress_line
    position absolute
    top 0
    left 0
    width 0%
    height 100%
    background-color #5BAF09
    border-top-left-radius 6px
    border-bottom-left-radius 6px
  .sip_start_progress_text
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    font-family Roboto
    font-style normal
    font-weight bold
    font-size 21px
    line-height 130%
    text-align center
    color #FFFFFF
    @media screen and (max-width: 900px)
      font-size 17px
  .sip_start_progress_bg
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-image: url('https://ria.ru/ips/gpn-game/sip_start_progress_bg.png')
    background-size cover
    @media screen and (max-width: 900px)
      background-image: url('https://ria.ru/ips/gpn-game/sip_start_progress_bg_mob.png')

.sip_preloader
  position: absolute
  top 0
  left 0
  width 100%
  height 100%
  transition opacity .5s
  .sip_preloader_text
    position: absolute
    top 71%
    left 50%
    transform: translate(-50%, -50%)
    max-width 678px
    width 100%
    text-align: center
    @media screen and (max-width: 900px)
      padding 20px
  .sip_preloader_title
    font-family 'Montserrat', sans-serif
    font-style normal
    font-weight 900
    font-size 55.7647px
    line-height 68px
    text-align center
    text-transform uppercase
    margin-bottom 10px
    color #FFF
    @media screen and (max-width: 900px)
      font-size: 26px;
      line-height: 32px;
  .sip_preloader_body
    font-family Roboto
    font-style normal
    font-weight normal
    font-size 21px
    line-height 130%
    text-align center
    color #BCE2E3
    margin-bottom 35px
    @media screen and (max-width: 900px)
      font-size: 16px;
      line-height: 130%;
      margin-bottom 15px
  .sip_start
    cursor: pointer
    background #5BAF09
    box-shadow inset 0px -3px 0px rgba(0, 0, 0, 0.2)
    border-radius 6px
    color #FFF
    padding 15px 35px
    display: inline-block
    span
      font-size: 18px;
      line-height: 92%;
      text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.25);
  img
    object-fit cover
    object-position 50% 0%
    width 100%
    height 100%
</style>
